import React from "react";

const Footer = () => {
  return (
    <div className="bg-black py-2">
      <p className="text-neutrals-200 text-center leading-snug text-[10px]">
        Copyright © 2026 Kult Works- Tektree Software Services Pvt Ltd. KW Ver
        01.01
      </p>
    </div>
  );
};

export default Footer;
